exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title__Fields-module___2xgkF {\n  margin-bottom: 8px;\n}\n\n.wrapper__Fields-module___10ECB {\n  position: relative;\n}\n\n.mark__Fields-module___bkIQx {\n  position: absolute;\n  left: 60px;\n  top: -10px;\n}\n\n.buttonNew__Fields-module___XS2H3 {\n  margin-top: 8px;\n}\n", ""]);

// Exports
exports.locals = {
	"title": "title__Fields-module___2xgkF",
	"wrapper": "wrapper__Fields-module___10ECB",
	"mark": "mark__Fields-module___bkIQx",
	"buttonNew": "buttonNew__Fields-module___XS2H3"
};